import { render, staticRenderFns } from "./ImportJournal.vue?vue&type=template&id=631efcfa&scoped=true"
import script from "./ImportJournal.vue?vue&type=script&lang=js"
export * from "./ImportJournal.vue?vue&type=script&lang=js"
import style0 from "./ImportJournal.vue?vue&type=style&index=0&id=631efcfa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "631efcfa",
  null
  
)

export default component.exports